/* jshint validthis: true */
/* @ngInject */
function svgToolboxCustomerFontService (FontsBaseService) {
  this.oFonts = {
    Aileron: {
      displayName: 'Aileron',
      className: 'Aileron',
      fontFamily: 'Aileron',
      hasBold: true,
      hasItalic: true
    },
    AlfaSlabOne: {
      displayName: 'Alfa Slab One',
      className: 'AlfaSlabOne',
      fontFamily: 'AlfaSlabOne',
      hasBold: false,
      hasItalic: false
    },
    Allura: {
      displayName: 'Allura',
      className: 'Allura',
      fontFamily: 'Allura',
      hasBold: false,
      hasItalic: false
    },
    Almendra: {
      displayName: 'Almendra',
      className: 'Almendra',
      fontFamily: 'Almendra',
      hasBold: true,
      hasItalic: true
    },
    AmaticSC: {
      displayName: 'Amatic SC',
      className: 'AmaticSC',
      fontFamily: 'AmaticSC',
      hasBold: false,
      hasItalic: false
    },
    Amita: {
      displayName: 'Amita',
      className: 'Amita',
      fontFamily: 'Amita',
      hasBold: true,
      hasItalic: false
    },
    Anton: {
      displayName: 'Anton',
      className: 'Anton',
      fontFamily: 'Anton',
      hasBold: false,
      hasItalic: false
    },
    Arial: {
      displayName: 'Arial',
      className: 'Arial',
      fontFamily: 'Arial',
      hasBold: false,
      hasItalic: false
    },
    Arvo: {
      displayName: 'Arvo',
      className: 'Arvo',
      fontFamily: 'Arvo',
      hasBold: true,
      hasItalic: true
    },
    'Autour One': {
      displayName: 'Autour One',
      className: 'AutourOne',
      fontFamily: 'Autour One',
      hasBold: false,
      hasItalic: false
    },
    'Architects Daughter': {
      displayName: 'Architects Daughter',
      className: 'ArchitectsDaughter',
      fontFamily: 'Architects Daughter',
      hasBold: false,
      hasItalic: false
    },
    Bahiana: {
      displayName: 'Bahiana',
      className: 'Bahiana',
      fontFamily: 'Bahiana',
      hasBold: false,
      hasItalic: false
    },
    'Bebas Neue': {
      displayName: 'Bebas Neue',
      className: 'BebasNeue',
      fontFamily: 'Bebas Neue',
      hasBold: true,
      hasItalic: false
    },
    'Berkshire Swash': {
      displayName: 'Berkshire Swash',
      className: 'BerkshireSwash',
      fontFamily: 'Berkshire Swash',
      hasBold: false,
      hasItalic: false
    },
    Boogaloo: {
      displayName: 'Boogaloo',
      className: 'Boogaloo',
      fontFamily: 'Boogaloo',
      hasBold: false,
      hasItalic: false
    },
    'Bubblegum Sans': {
      displayName: 'Bubblegum Sans',
      className: 'BubblegumSans',
      fontFamily: 'Bubblegum Sans',
      hasBold: false,
      hasItalic: false
    },
    CabinSketch: {
      displayName: 'CabinSketch',
      className: 'CabinSketch',
      fontFamily: 'CabinSketch',
      hasBold: true,
      hasItalic: false
    },
    'Carter One': {
      displayName: 'Carter One',
      className: 'CarterOne',
      fontFamily: 'Carter One',
      hasBold: false,
      hasItalic: false
    },
    'Cherry Swash': {
      displayName: 'Cherry Swash',
      className: 'CherrySwash',
      fontFamily: 'Cherry Swash',
      hasBold: false,
      hasItalic: false
    },
    Chewy: {
      displayName: 'Chewy',
      className: 'Chewy',
      fontFamily: 'Chewy',
      hasBold: false,
      hasItalic: false
    },
    Cinzel: {
      displayName: 'Cinzel',
      className: 'Cinzel',
      fontFamily: 'Cinzel',
      hasBold: true,
      hasItalic: false
    },
    'Clicker Script': {
      displayName: 'Clicker Script',
      className: 'ClickerScript',
      fontFamily: 'Clicker Script',
      hasBold: false,
      hasItalic: false
    },
    Coiny: {
      displayName: 'Coiny',
      className: 'Coiny',
      fontFamily: 'Coiny',
      hasBold: false,
      hasItalic: false
    },
    'Coming Soon': {
      displayName: 'Coming Soon',
      className: 'ComingSoon',
      fontFamily: 'Coming Soon',
      hasBold: false,
      hasItalic: false
    },
    Courgette: {
      displayName: 'Courgette',
      className: 'Courgette',
      fontFamily: 'Courgette',
      hasBold: false,
      hasItalic: false
    },
    Coustard: {
      displayName: 'Coustard',
      className: 'Coustard',
      fontFamily: 'Coustard',
      hasBold: true,
      hasItalic: false
    },
    Economica: {
      displayName: 'Economica',
      className: 'Economica',
      fontFamily: 'Economica',
      hasBold: true,
      hasItalic: true
    },
    Edo: {
      displayName: 'Edo',
      className: 'Edo',
      fontFamily: 'Edo',
      hasBold: false,
      hasItalic: false
    },
    'Emilys Candy': {
      displayName: 'Emilys Candy',
      className: 'EmilysCandy',
      fontFamily: 'Emilys Candy',
      hasBold: false,
      hasItalic: false
    },
    Exo2Custom: {
      displayName: 'Exo 2 Thin',
      className: 'Exo2Custom',
      fontFamily: 'Exo2Custom',
      hasBold: true,
      hasItalic: true
    },
    Exo2: {
      displayName: 'Exo 2',
      className: 'Exo2',
      fontFamily: 'Exo2',
      hasBold: true,
      hasItalic: true
    },
    'Fredoka One': {
      displayName: 'Fredoka One',
      className: 'FredokaOne',
      fontFamily: 'Fredoka One',
      hasBold: false,
      hasItalic: false
    },
    Gidole: {
      displayName: 'Gidole',
      className: 'Gidole',
      fontFamily: 'Gidole',
      hasBold: false,
      hasItalic: false
    },
    Glegoo: {
      displayName: 'Glegoo',
      className: 'Glegoo',
      fontFamily: 'Glegoo',
      hasBold: false,
      hasItalic: false
    },
    'Gochi Hand': {
      displayName: 'Gochi Hand',
      className: 'GochiHand',
      fontFamily: 'Gochi Hand',
      hasBold: false,
      hasItalic: false
    },
    Gorditas: {
      displayName: 'Gorditas',
      className: 'Gorditas',
      fontFamily: 'Gorditas',
      hasBold: true,
      hasItalic: false
    },
    Graduate: {
      displayName: 'Graduate',
      className: 'Graduate',
      fontFamily: 'Graduate',
      hasBold: false,
      hasItalic: false,
      regularFontFamily: 'Graduate'
    },
    'Grand Hotel': {
      displayName: 'Grand Hotel',
      className: 'GrandHotel',
      fontFamily: 'Grand Hotel',
      hasBold: false,
      hasItalic: false
    },
    Gruppo: {
      displayName: 'Gruppo',
      className: 'Gruppo',
      fontFamily: 'Gruppo',
      hasBold: false,
      hasItalic: false
    },
    HammersmithOne: {
      displayName: 'HammersmithOne',
      className: 'HammersmithOne',
      fontFamily: 'HammersmithOne',
      hasBold: false,
      hasItalic: false
    },
    'Henny Penny': {
      displayName: 'Henny Penny',
      className: 'HennyPenny',
      fontFamily: 'Henny Penny',
      hasBold: false,
      hasItalic: false
    },
    'Josefin Sans': {
      displayName: 'Josefin Sans',
      className: 'JosefinSans',
      fontFamily: 'Josefin Sans',
      hasBold: true,
      hasItalic: true
    },
    Kavoon: {
      displayName: 'Kavoon',
      className: 'Kavoon',
      fontFamily: 'Kavoon',
      hasBold: false,
      hasItalic: false
    },
    Knewave: {
      displayName: 'Knewave',
      className: 'Knewave',
      fontFamily: 'Knewave',
      hasBold: false,
      hasItalic: false
    },
    'Kite One': {
      displayName: 'Kite One',
      className: 'KiteOne',
      fontFamily: 'Kite One',
      hasBold: false,
      hasItalic: false
    },
    'League Gothic': {
      displayName: 'League Gothic',
      className: 'LeagueGothic',
      fontFamily: 'League Gothic',
      hasBold: false,
      hasItalic: true
    },
    'League Spartan': {
      displayName: 'League Spartan',
      className: 'LeagueSpartan',
      fontFamily: 'League Spartan',
      hasBold: false,
      hasItalic: false
    },
    'Libre Baskerville': {
      displayName: 'Libre Baskerville',
      className: 'LibreBaskerville',
      fontFamily: 'Libre Baskerville',
      hasBold: true,
      hasItalic: false
    },
    'Lilita One': {
      displayName: 'Lilita One',
      className: 'LilitaOne',
      fontFamily: 'Lilita One',
      hasBold: false,
      hasItalic: false
    },
    Lobster: {
      displayName: 'Lobster',
      className: 'Lobster',
      fontFamily: 'Lobster',
      hasBold: false,
      hasItalic: false
    },
    'Londrina Shadow': {
      displayName: 'Londrina Shadow',
      className: 'LondrinaShadow',
      fontFamily: 'Londrina Shadow',
      hasBold: false,
      hasItalic: false,
      regularFontFamily: 'LondrinaShadow'
    },
    'Londrina Sketche': {
      displayName: 'Londrina Sketche',
      className: 'LondrinaSketche',
      fontFamily: 'Londrina Sketche',
      hasBold: false,
      hasItalic: false,
      regularFontFamily: 'LondrinaSketche'
    },
    'Londrina Solid': {
      displayName: 'Londrina Solid',
      className: 'LondrinaSolid',
      fontFamily: 'Londrina Solid',
      hasBold: false,
      hasItalic: false,
      regularFontFamily: 'LondrinaSolid'
    },
    Merriweather: {
      displayName: 'Merriweather',
      className: 'Merriweather',
      fontFamily: 'Merriweather',
      hasBold: true,
      hasItalic: true
    },
    MontserratUltraLightCustom: {
      displayName: 'Montserrat Ultra Light',
      className: 'MontserratUltraLightCustom',
      fontFamily: 'MontserratUltraLightCustom',
      hasBold: false,
      hasItalic: false
    },
    Montserrat: {
      displayName: 'Montserrat',
      className: 'Montserrat',
      fontFamily: 'Montserrat',
      hasBold: true,
      hasItalic: false
    },
    MontserratBlackCustom: {
      displayName: 'Montserrat Black',
      className: 'MontserratBlackCustom',
      fontFamily: 'MontserratBlackCustom',
      hasBold: false,
      hasItalic: false
    },
    'Mr Dafoe': {
      displayName: 'Mr Dafoe',
      className: 'MrDafoe',
      fontFamily: 'Mr Dafoe',
      hasBold: false,
      hasItalic: false
    },
    Niconne: {
      displayName: 'Niconne',
      className: 'Niconne',
      fontFamily: 'Niconne',
      hasBold: false,
      hasItalic: false
    },
    Nunito: {
      displayName: 'Nunito',
      className: 'Nunito',
      fontFamily: 'Nunito',
      hasBold: true,
      hasItalic: false
    },
    'Oleo Script': {
      displayName: 'Oleo Script',
      className: 'OleoScript',
      fontFamily: 'Oleo Script',
      hasBold: true,
      hasItalic: false
    },
    'Open Sans': {
      displayName: 'Open Sans',
      className: 'OpenSans',
      fontFamily: 'Open Sans',
      hasBold: true,
      hasItalic: true
    },
    'Open Sans Custom': {
      displayName: 'Open Sans Light',
      className: 'OpenSansCustom',
      fontFamily: 'Open Sans Custom',
      hasBold: false,
      hasItalic: true
    },
    Oregano: {
      displayName: 'Oregano',
      className: 'Oregano',
      fontFamily: 'Oregano',
      hasBold: false,
      hasItalic: true
    },
    Oswald: {
      displayName: 'Oswald',
      className: 'Oswald',
      fontFamily: 'Oswald',
      hasBold: true,
      hasItalic: true
    },
    Pacifico: {
      displayName: 'Pacifico',
      className: 'Pacifico',
      fontFamily: 'Pacifico',
      hasBold: false,
      hasItalic: false
    },
    'Permanent Marker': {
      displayName: 'Permanent Marker',
      className: 'PermanentMarker',
      fontFamily: 'Permanent Marker',
      hasBold: false,
      hasItalic: false
    },
    Quando: {
      displayName: 'Quando',
      className: 'Quando',
      fontFamily: 'Quando',
      hasBold: false,
      hasItalic: false
    },
    Raleway: {
      displayName: 'Raleway',
      className: 'Raleway',
      fontFamily: 'Raleway',
      hasBold: true,
      hasItalic: true
    },
    RalewayCustom: {
      displayName: 'Raleway Black',
      className: 'RalewayCustom',
      fontFamily: 'RalewayCustom',
      hasBold: false,
      hasItalic: true
    },
    Ribeye: {
      displayName: 'Ribeye',
      className: 'Ribeye',
      fontFamily: 'Ribeye',
      hasBold: false,
      hasItalic: false
    },
    'Rubik Mono One': {
      displayName: 'Rubik Mono One',
      className: 'RubikMonoOne',
      fontFamily: 'Rubik Mono One',
      hasBold: false,
      hasItalic: false
    },
    Rye: {
      displayName: 'Rye',
      className: 'Rye',
      fontFamily: 'Rye',
      hasBold: false,
      hasItalic: false
    },
    Sacramento: {
      displayName: 'Sacramento',
      className: 'Sacramento',
      fontFamily: 'Sacramento',
      hasBold: false,
      hasItalic: false
    },
    'Six Caps': {
      displayName: 'Six Caps',
      className: 'SixCaps',
      fontFamily: 'Six Caps',
      hasBold: false,
      hasItalic: false
    },
    Sniglet: {
      displayName: 'Sniglet',
      className: 'Sniglet',
      fontFamily: 'Sniglet',
      hasBold: true,
      hasItalic: false
    },
    'Text Me One': {
      displayName: 'Text Me One',
      className: 'TextMeOne',
      fontFamily: 'Text Me One',
      hasBold: false,
      hasItalic: false
    },
    Trocchi: {
      displayName: 'Trocchi',
      className: 'Trocchi',
      fontFamily: 'Trocchi',
      hasBold: true,
      hasItalic: false
    },
    Ubuntu: {
      displayName: 'Ubuntu',
      className: 'Ubuntu',
      fontFamily: 'Ubuntu',
      hasBold: true,
      hasItalic: true
    },
    'Vast Shadow': {
      displayName: 'Vast Shadow',
      className: 'VastShadow',
      fontFamily: 'Vast Shadow',
      hasBold: false,
      hasItalic: false
    },
    VT323: {
      displayName: 'VT323',
      className: 'VT323',
      fontFamily: 'VT323',
      hasBold: false,
      hasItalic: false
    },
    Yellowtail: {
      displayName: 'Yellowtail',
      className: 'Yellowtail',
      fontFamily: 'Yellowtail',
      hasBold: false,
      hasItalic: false
    }
  }

  this.oCustomFonts = {}
  this.currentFontsCount = 0
  this.totalFontsCount = 0

  this.getAllFonts = function () {
    return jQuery.extend({}, this.oCustomFonts, this.oFonts)
  }

  this.getDefaultFonts = function () {
    return this.oFonts
  }

  this.addCustomFonts = function (aCustomFonts, count) {
    const fonts = this.getCustomFontsObj(aCustomFonts)

    if (!this.oCustomFonts || jQuery.isEmptyObject(this.oCustomFonts)) {
      this.oCustomFonts = {}
    }

    this.oCustomFonts = Object.assign(this.oCustomFonts, fonts)
    this.currentFontsCount = Object.keys(this.oCustomFonts).length
    this.totalFontsCount = count || this.currentFontsCount
  }

  this.getCustomFontsObj = function (customFonts) {
    if (!customFonts) {
      return
    }
    const fontsObj = {}

    customFonts.forEach(function (oFont) {
      fontsObj[oFont.postScriptName] = {
        displayName: oFont.fullName.replace(/\.(ttf|otf)$/i, ''),
        className: oFont.familyName,
        fontFamily: oFont.familyName,
        postScriptName: oFont.postScriptName,
        hasBold: false,
        hasItalic: false
      }
    })

    return fontsObj
  }

  this.findMissingFonts = function (aFonts, aAllFonts) {
    var self = this
    const object = {
      missingFonts: [],
      fontsToLoad: []
    }

    aFonts.forEach(function (svgText) {
      const responses = self.findEquivalentFont(svgText, aAllFonts)
      responses.forEach(response => {
        if (response && response.id) {
          object.fontsToLoad.push(response)
        } else {
          object.missingFonts.push(svgText)
        }
      })
    })

    return object
  }.bind(this)

  this.findEquivalentFont = function (svgText, aAllFonts) {
    let sFonts = ['Arial']
    let shouldReplaceFont = true
    let multipleFonts = false
    if (svgText && svgText.font) {
      sFonts = [svgText.node.getAttribute('font-family')]
      if (!sFonts[0]) {
        const childrens = Array.from(svgText.node.children)
        const childrenHasFont = childrens.find(child => child.hasAttribute('font-family'))
        sFonts = childrenHasFont ? childrens.map(element => element.getAttribute('font-family')).filter(Boolean) : ['Helvetica, Arial, sans-serif']

        const uniqueFonts = [...new Set(sFonts)]
        if (sFonts.length === 1) {
          shouldReplaceFont = false
        }

        if (uniqueFonts.length > 1) {
          multipleFonts = true
        }
      }
    }

    const formatFontName = (font) => {
      let sFont = font.toLowerCase()
      sFont = sFont.replaceAll("'", '')
      sFont = sFont.replaceAll(' ', '')
      sFont = sFont.replaceAll('-', '')
      sFont = sFont.replaceAll('.ttf', '')
      sFont = sFont.replaceAll('.otf', '')
      return sFont
    }

    const fonts = sFonts.map((sFont) => {
      sFont = formatFontName(sFont)

      // try to find match by postScriptName
      var oFont = aAllFonts.find(item => {
        if (item.postScriptName) {
          return sFont === formatFontName(item.postScriptName)
        }
      })

      if (!oFont) {
        oFont = aAllFonts.find(item => {
          if (item.familyName) {
            let familyNameLowerCase = item.familyName.toLowerCase()
            familyNameLowerCase = familyNameLowerCase.replaceAll('-', '')
            return familyNameLowerCase === sFont
          }
        }) // try to find match by familyName
      }

      if (oFont && shouldReplaceFont) {
        if (multipleFonts) {
          svgText.node.children.forEach(child => {
            const childFont = formatFontName(child.getAttribute('font-family'))
            const formattedFont = formatFontName(oFont.postScriptName)
            if (sFont === formattedFont && childFont === formattedFont) {
              child.setAttribute('font-family', oFont.fontFamily)
            }
          })
        } else {
          svgText.font('family', oFont.fontFamily)
          const childHasFont = svgText.node.children[0]?.hasAttribute('font-family')

          if (childHasFont) {
            svgText.node.children.forEach(child => {
              child.setAttribute('font-family', oFont.fontFamily)
            })
          }
        }
      }

      return oFont
    })

    return fonts
  }

  return this
}

export { svgToolboxCustomerFontService }
